import { render, staticRenderFns } from "./write.vue?vue&type=template&id=160ec50c&scoped=true&"
import script from "./write.vue?vue&type=script&lang=ts&"
export * from "./write.vue?vue&type=script&lang=ts&"
import style0 from "./write.vue?vue&type=style&index=0&id=160ec50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ec50c",
  null
  
)

export default component.exports